{
  "header": "Logs",
  "severity": {
    "down": "Down",
    "high": "High",
    "low": "Low",
    "medium": "Medium"
  },
  "subrecords": {
    "alert_end": "Alert closed",
    "alert_start": "Alert opened",
    "error": "Unable to load sub-records for this alert.",
    "no_data": "No alert sub-records."
  },
  "table": {
    "firewall": {
      "api_error": "There was an error loading logs",
      "columns": {
        "action": "Action",
        "company": "Company",
        "destination_ip": "Destination IP",
        "destination_port": "Destination Port",
        "event_type": "Event Type",
        "log": "Log",
        "priority": "Rule #",
        "proto": "Protocol",
        "rule": "Rule",
        "site": "Site",
        "source_ip": "Source IP",
        "source_port": "Source Port",
        "timestamp": "Timestamp"
      },
      "filters": {
        "action": "Action",
        "company_id": "Company",
        "destination_ip": "Destination IP",
        "destination_port": "Destination Port",
        "event_type": "Event Type",
        "path": "Logs > Firewall Logs table",
        "proto": "Protocol",
        "site_id": "Site",
        "source_ip": "Source IP",
        "source_port": "Source Port"
      },
      "no_data": "No Firewall Logs Available"
    },
    "general": {
      "api_error": "There was an error loading logs",
      "columns": {
        "company": "Company",
        "log": "Log",
        "message": "Message",
        "modified_by": "Modified By",
        "severity": "Severity",
        "site": "Site",
        "timestamp": "Timestamp",
        "type": "Type"
      },
      "filters": {
        "company_id": "Company",
        "modified_by": "Modified By",
        "path": "Logs > Logs table",
        "severity": "Severity",
        "site_id": "Site",
        "type": "Type"
      },
      "no_data": "No Logs Available"
    },
    "vpn": {
      "api_error": "There was an error loading logs",
      "columns": {
        "company_id": "Company",
        "log": "Log",
        "site_id": "Site",
        "timestamp": "Timestamp",
        "tunnel_name": "Connection Name"
      },
      "filters": {
        "company_id": "Company",
        "path": "Logs > VPN Logs table",
        "site_id": "Site",
        "tunnel_id": "Connection Name"
      },
      "no_data": "No VPN Logs Available"
    }
  },
  "title": "Logs",
  "type": {
    "account": "Account Settings",
    "alert": "Alert",
    "company": "Company Settings",
    "job": "Site Diagnostics",
    "site": "Site Settings"
  }
}
